import React from 'react';
import { FileText, Phone } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
import { Button } from '../ui/Button';
interface PageHeroProps {
  eyebrow: string;
  title: string;
  intro: string;
  primaryLabel?: string;
  primaryAction?: 'upload' | 'quote';
}
export function PageHero({
  eyebrow,
  title,
  intro,
  primaryLabel = 'Upload a contract',
  primaryAction = 'upload'
}: PageHeroProps) {
  const {
    openUpload,
    openQuote
  } = useDrawers();
  const primary = primaryAction === 'upload' ? openUpload : openQuote;
  const secondary = primaryAction === 'upload' ? openQuote : openUpload;
  return <section className="bg-background px-5 py-8 md:px-6 md:py-10" data-id="element-526" data-mp="1grv7qvine0di">
      <div className="mx-auto max-w-7xl" data-id="element-527" data-mp="1lr801vsafznh">
        <div className="max-w-4xl border-l-4 border-peach pl-5 md:pl-7" data-id="element-528" data-mp="1lpwubqfa8htq">
          <p className="eyebrow text-brand-blue" data-id="element-529" data-mp="29gamdgxvagob">{eyebrow}</p>
          <h1 className="mt-3 font-serif text-4xl leading-[1.08] text-ink md:text-5xl lg:text-6xl" data-id="element-530" data-mp="2e7sd7c66f0vk">
            {title}
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted-ink" data-id="element-531" data-mp="3oy8bmlab9erl">
            {intro}
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row" data-id="element-532" data-mp="3jznbelv26v35">
            <Button onClick={primary} variant="accent" size="lg" data-id="element-533" data-mp="1kmefayp58ur">
              <FileText className="h-5 w-5" data-id="element-534" data-mp="1lxn9p7016sq" />
              {primaryLabel}
            </Button>
            <Button onClick={secondary} variant="outline" size="lg" data-id="element-535" data-mp="3swxn28bsgm8l">
              {primaryAction === 'upload' ? 'Get a free quote' : 'Upload a contract'}
            </Button>
          </div>
          <a href="tel:+61386172600" className="mt-5 inline-flex items-center gap-2 font-semibold text-ink transition-colors hover:text-accent" data-id="element-536" data-mp="6la51vj0jnog">
            <Phone className="h-4 w-4 text-accent" data-id="element-537" data-mp="ghvbmlaol6ue" />
            Call (03) 8617 2600
          </a>
        </div>
      </div>
    </section>;
}